// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.EmptyReturnAcceptance .EmptyReturnAcceptance__dateFilters {
    margin-top: 1em;
    display: flex;
    flex-direction: row;
  }

    .EmptyReturnAcceptance .EmptyReturnAcceptance__dateFilters :hover {
      background: var(--color-gray-3);
    }

    .EmptyReturnAcceptance .EmptyReturnAcceptance__dateFilters-active {
      background: var(--color-gray-2);
    }
  .EmptyReturnAcceptance .EmptyReturnAcceptance__scrape-button {
    background: var(--color-green-3);
    color: var(--text-color-primary-3);
    float: right;
  }
  .EmptyReturnAcceptance {

  width: 100%;
  padding: 20px;
}
  .EmptyReturnAcceptance__selectedContainer {
    display: flex;
    flex-direction: row;
    align-items: stretch;
    margin-bottom: 20px;
    width: 100%;
  }
  .EmptyReturnAcceptance__selectedContainer-wrapper {
      width: 100%;
      height: 100vh;
    }
  .EmptyReturnAcceptance__selectedContainer-column {
      font-size: 18px;
      font-weight: bold;
      border: solid 1px var(--color-gray-3);
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }
  .EmptyReturnAcceptance__selectedContainer-column-row {
        font-size: 16px;
        color: var(--color-blue-3);
      }
  .EmptyReturnAcceptance .right-sidebar-navigation__content-open {
    background: white;
    box-shadow: 0 2px 2px 0 #bbbcbd;
    padding: 20px;
    height: 100vh;
    overflow-y: scroll;
  }
  .EmptyReturnAcceptance .CopyButton,
  .EmptyReturnAcceptance .PhoneButton {
    display: inline;
    position: relative;
    left: 4px;
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }
  .EmptyReturnAcceptance td:hover .CopyButton,
  .EmptyReturnAcceptance *:hover > .CopyButton,
  .EmptyReturnAcceptance *:hover > .PhoneButton,
  .EmptyReturnAcceptance td:hover .PhoneButton {
    opacity: 1;
  }
  .EmptyReturnAcceptance .EmptyReturnAcceptance__last-upsert-date {
    float: right;
    font-size: initial;
    font-weight: initial;
  }
  .EmptyReturnAcceptance__table .EmptyReturnAcceptance__accepting-yes,
    .EmptyReturnAcceptance__table .EmptyReturnAcceptance__accepting-dual {
      font-weight: bold;
    }
  .EmptyReturnAcceptance__table .EmptyReturnAcceptance__accepting-no {
      color: var(--color-gray-3);
    }
  .EmptyReturnAcceptance__table {

    background: var(--bg-color-0);
    padding: 3px;
    border: solid 1px #d0d0d0;
    flex-grow: 1;
}
  .EmptyReturnAcceptance__table tbody tr:last-child th,
      .EmptyReturnAcceptance__table tbody tr:last-child td {
        border-bottom: 0;
      }
  .EmptyReturnAcceptance__table th,
    .EmptyReturnAcceptance__table td {
      text-align: center;
      border-right: solid 1px var(--color-grayscale-4);
      border-bottom: solid 1px var(--color-grayscale-4);
      padding: 3px;
    }
  .EmptyReturnAcceptance__table th:last-child, .EmptyReturnAcceptance__table td:last-child {
        border-right: 0;
      }
  .EmptyReturnAcceptance__options {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding: 20px;
  }
  .EmptyReturnAcceptance__options input {
      width: 200px;
      margin-right: 20px;
    }
  .EmptyReturnAcceptance__options button {
      margin-right: 20px;
    }
  .EmptyReturnAcceptance__table {
    width: 100%;
  }
  .EmptyReturnAcceptance__table th {
      text-align: left;
    }
  .EmptyReturnAcceptance__table td {
      padding: 10px 0;
    }
  .EmptyReturnAcceptance__table th:first-child {
      min-width: 30px;
      padding-right: 10px;
    }
  .EmptyReturnAcceptance__table th:nth-child(2) {
      min-width: 120px;
    }
  .EmptyReturnAcceptance__table_showMuted th:first-child {
        padding-right: 17px;
      }
  .EmptyReturnAcceptance__table_row input[type='checkbox'] {
      cursor: pointer;
    }
  .EmptyReturnAcceptance__table_row-muted {
      color: var(--color-grayscale-5);
      font-style: italic;
    }
  .EmptyReturnAcceptance__table-job-number {
      min-width: 120px;
    }
  .EmptyReturnAcceptance__small_col {
    max-width: 120px;
  }
  .EmptyReturnAcceptance__show-hide-button {
    margin: 10px 0;
  }
`, "",{"version":3,"sources":["webpack://./app/_blessed/components/features/Admin/features/EmptyReturnAcceptance/style.css","<no source>"],"names":[],"mappings":"AACE;IACE,eAAe;IACf,aAAa;IACb,mBAAmB;EASrB;;IAPE;MACE,+BAA+B;IACjC;;IAEA;MACE,+BAA+B;IACjC;EAGF;IACE,gCAAgC;IAChC,kCAAkC;IAClC,YAAY;EACd;ECnBF;;EDqBE,WAAW;EACX;CCtBF;EDwBE;IACE,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;EAqBb;EAnBE;MACE,WAAW;MACX,aAAa;IACf;EAEA;MACE,eAAe;MACf,iBAAiB;MACjB,qCAAqC;MACrC,aAAa;MACb,aAAa;MACb,sBAAsB;MACtB,8BAA8B;IAMhC;EAJE;QACE,eAAe;QACf,0BAA0B;MAC5B;EAIJ;IACE,iBAAiB;IACjB,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,kBAAkB;EACpB;EAEA;;IAEE,eAAe;IACf,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,oCAAoC;EACtC;EAEA;;;;IAIE,UAAU;EACZ;EAEA;IACE,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;EAGE;;MAEE,iBAAiB;IACnB;EAEA;MACE,0BAA0B;IAC5B;EC1FJ;;ID4FI,6BAA6B;IAC7B,YAAY;IACZ,yBAAyB;IACzB;CC/FJ;EDkGM;;QAEE,gBAAgB;MAClB;EAGF;;MAEE,kBAAkB;MAClB,gDAAgD;MAChD,iDAAiD;MACjD,YAAY;IAKd;EAHE;QACE,eAAe;MACjB;EAIJ;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,aAAa;EAUf;EARE;MACE,YAAY;MACZ,kBAAkB;IACpB;EAEA;MACE,kBAAkB;IACpB;EAGF;IACE,WAAW;EAqCb;EAnCE;MACE,gBAAgB;IAClB;EAEA;MACE,eAAe;IACjB;EAEA;MACE,eAAe;MACf,mBAAmB;IACrB;EAEA;MACE,gBAAgB;IAClB;EAGE;QACE,mBAAmB;MACrB;EAGF;MACE,eAAe;IACjB;EAEA;MACE,+BAA+B;MAC/B,kBAAkB;IACpB;EAEA;MACE,gBAAgB;IAClB;EAGF;IACE,gBAAgB;EAClB;EAEA;IACE,cAAc;EAChB","sourcesContent":[".EmptyReturnAcceptance {\n  .EmptyReturnAcceptance__dateFilters {\n    margin-top: 1em;\n    display: flex;\n    flex-direction: row;\n\n    :hover {\n      background: var(--color-gray-3);\n    }\n\n    &-active {\n      background: var(--color-gray-2);\n    }\n  }\n\n  .EmptyReturnAcceptance__scrape-button {\n    background: var(--color-green-3);\n    color: var(--text-color-primary-3);\n    float: right;\n  }\n\n  width: 100%;\n  padding: 20px;\n\n  &__selectedContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: stretch;\n    margin-bottom: 20px;\n    width: 100%;\n\n    &-wrapper {\n      width: 100%;\n      height: 100vh;\n    }\n\n    &-column {\n      font-size: 18px;\n      font-weight: bold;\n      border: solid 1px var(--color-gray-3);\n      padding: 20px;\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n\n      &-row {\n        font-size: 16px;\n        color: var(--color-blue-3);\n      }\n    }\n  }\n\n  .right-sidebar-navigation__content-open {\n    background: white;\n    box-shadow: 0 2px 2px 0 #bbbcbd;\n    padding: 20px;\n    height: 100vh;\n    overflow-y: scroll;\n  }\n\n  .CopyButton,\n  .PhoneButton {\n    display: inline;\n    position: relative;\n    left: 4px;\n    opacity: 0;\n    transition: opacity 0.2s ease-in-out;\n  }\n\n  td:hover .CopyButton,\n  *:hover > .CopyButton,\n  *:hover > .PhoneButton,\n  td:hover .PhoneButton {\n    opacity: 1;\n  }\n\n  .EmptyReturnAcceptance__last-upsert-date {\n    float: right;\n    font-size: initial;\n    font-weight: initial;\n  }\n\n  &__table {\n    .EmptyReturnAcceptance__accepting-yes,\n    .EmptyReturnAcceptance__accepting-dual {\n      font-weight: bold;\n    }\n\n    .EmptyReturnAcceptance__accepting-no {\n      color: var(--color-gray-3);\n    }\n\n    background: var(--bg-color-0);\n    padding: 3px;\n    border: solid 1px #d0d0d0;\n    flex-grow: 1;\n\n    tbody tr:last-child {\n      th,\n      td {\n        border-bottom: 0;\n      }\n    }\n\n    th,\n    td {\n      text-align: center;\n      border-right: solid 1px var(--color-grayscale-4);\n      border-bottom: solid 1px var(--color-grayscale-4);\n      padding: 3px;\n\n      &:last-child {\n        border-right: 0;\n      }\n    }\n  }\n\n  &__options {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    padding: 20px;\n\n    input {\n      width: 200px;\n      margin-right: 20px;\n    }\n\n    button {\n      margin-right: 20px;\n    }\n  }\n\n  &__table {\n    width: 100%;\n\n    th {\n      text-align: left;\n    }\n\n    td {\n      padding: 10px 0;\n    }\n\n    th:first-child {\n      min-width: 30px;\n      padding-right: 10px;\n    }\n\n    th:nth-child(2) {\n      min-width: 120px;\n    }\n\n    &_showMuted {\n      th:first-child {\n        padding-right: 17px;\n      }\n    }\n\n    &_row input[type='checkbox'] {\n      cursor: pointer;\n    }\n\n    &_row-muted {\n      color: var(--color-grayscale-5);\n      font-style: italic;\n    }\n\n    &-job-number {\n      min-width: 120px;\n    }\n  }\n\n  &__small_col {\n    max-width: 120px;\n  }\n\n  &__show-hide-button {\n    margin: 10px 0;\n  }\n}\n",null],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
